import styled from 'styled-components';

const Slide = styled.div<{ padded?: boolean }>`
    display: grid;
    align-items: center;
    grid-gap: 10px;
    grid-template-columns: repeat(4, 1fr);

    ${({ padded }) => (padded ? 'padding: 10px;' : '')}
`;

const Container = styled.div`
    grid-column: 1 / 6;
    /**
	 * This is a fix to address a problem with the antd carousel in Firefox
	 * https://github.com/kenwheeler/slick/issues/982
	 */
    min-width: 100%;
    width: 0;
    overflow: hidden;

    &.is-dark {
        .ant-carousel {
            .slick-list {
                color: white;
                background-color: #364d79;
            }

            .ant-carousel {
                .slick-dots {
                    li button {
                        background-color: rgba(194, 207, 231, 1);
                    }

                    li.slick-active button {
                        background-color: rgba(194, 207, 231, 1);
                    }
                }
            }
        }
    }

    .ant-carousel {
        .ant-carousel {
            ${Slide} {
                padding: 0;
            }
        }

        .slick-dots {
            margin: 0;
            height: 20px;

            li {
                margin: 0 2px;

                button {
                    height: 20px;
                    background-color: #364d79;
                }

                &.slick-active button {
                    background-color: #364d79;
                }
            }
        }

        .slick-dots-top {
            top: 0;
        }

        .slick-dots-bottom {
            bottom: 0;
        }

        .slick-slide:not(.slick-active) {
            max-height: 0;
            overflow: hidden;
            pointer-events: none;

            .ant-carousel {
                .slick-active {
                    max-height: 0;
                    pointer-events: none;
                }
            }
        }
    }

    &.show-dots {
        &.top {
            > .ant-carousel > .slick-slider {
                padding-top: 30px;
            }
        }

        &.bottom {
            > .ant-carousel > .slick-slider {
                padding-bottom: 30px;
            }
        }
    }
`;

export { Container, Slide };
